package crashreporting

interface CrashReporter {
    fun capture(throwable: Throwable, extras: Map<String, String> = emptyMap())
    fun identify(userId: String?)
    fun setTag(key: String, value: String)
    fun clearUser()
}
